import { useTranslations } from "@/i18n/client";

import { klaviyoTracker } from "@/lib/klaviyo";
import {
  BaseSelection,
  BaseSelectionItem,
} from "@frend-digital/centra-types/selection";
import { useAddToCart } from "@frend-digital/centra/client";
import clsx from "clsx";
import styles from "../Cart/index.module.css";

export interface CartItemToastProps {
  item: BaseSelectionItem;
}

export const CartItemToast = ({ item }: CartItemToastProps) => {
  const { mutate: addToCart, data } = useAddToCart();

  const handleClick = () => {
    if (!item?.item) return;

    addToCart({
      itemId: item.item,
    });
    if (data?.selection) {
      klaviyoTracker.addToCart(data.selection as BaseSelection, item);
    }
  };
  const t = useTranslations("cart");
  return (
    <div className={clsx(styles.emptyCart, "cart-toast")}>
      <p>{t("removedItem")}</p>
      <button onClick={handleClick}>{t("restore")}</button>
    </div>
  );
};
